var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoSmall = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "logo_small") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-217.000000, -217.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo_small",
  transform: "translate(217.000000, 217.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#1BA785",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.746188,9.00038326 C12.4770282,8.99011953 13.1959456,9.18618793 13.8203817,9.56607248 C14.4354168,9.94367166 14.9381861,10.4789944 15.2765077,11.1164799 C15.6409012,11.8066978 15.8246942,12.5779076 15.8107697,13.3582853 C15.8213643,14.1382983 15.6377647,14.9086966 15.2765077,15.6000907 C14.9395177,16.2496155 14.4372701,16.798836 13.8203817,17.1924011 C13.200818,17.5859463 12.4801195,17.7906902 11.746188,17.7816607 L7.637,17.781 L7.63708438,22.8100093 C7.64188339,23.0347499 7.55925857,23.252579 7.40661841,23.4176014 C7.25677851,23.5840539 7.04120985,23.6760299 6.81735881,23.6690188 C6.59059679,23.6795102 6.37120465,23.5871345 6.22024242,23.4176014 C6.07347417,23.2497293 5.99497828,23.0329311 6.00025217,22.8100093 L6.00025217,9.83844136 C5.99467303,9.61467222 6.08187732,9.39855724 6.24119387,9.24132497 C6.39847041,9.08207486 6.61455538,8.99488268 6.83831026,9.00038326 L11.746188,9.00038326 Z M17.9333173,9.00038913 C18.1599362,8.99612682 18.3787998,9.08291757 18.5409095,9.24133083 C18.7058523,9.39553457 18.7972918,9.61270339 18.7923269,9.83844722 L18.7923269,22.011241 L25.1406169,22.011241 C25.3672358,22.0069787 25.5860994,22.0937694 25.748209,22.2521827 C25.9131519,22.4063864 26.0045914,22.6235553 25.9996265,22.8492991 C26.0066375,23.0731501 25.9146616,23.2887188 25.748209,23.4385587 C25.5827786,23.5902469 25.3649965,23.6719152 25.1406169,23.6664057 L17.8914144,23.6664057 C17.6656706,23.6713706 17.4485018,23.5799311 17.294298,23.4149883 C17.1358848,23.2528787 17.049094,23.0340151 17.0533563,22.8073962 L17.0533563,9.83844722 C17.0483914,9.61270339 17.1398309,9.39553457 17.3047738,9.24133083 C17.4736409,9.08020027 17.7000135,8.9934241 17.9333173,9.00038913 Z M11.746188,10.6136451 L7.637,10.613 L7.637,16.165 L11.746188,16.1657799 C12.1812399,16.1738436 12.6073264,16.0416099 12.9613722,15.7886538 C13.3227391,15.5225003 13.6110107,15.1693676 13.7994303,14.7620326 C14.010033,14.3242638 14.1175405,13.8440635 14.1137021,13.3582853 C14.1238671,12.8718538 14.0160342,12.3902005 13.7994303,11.954538 C13.6041641,11.5660014 13.316364,11.2314338 12.9613722,10.9802955 C12.6048287,10.733575 12.1796907,10.6053006 11.746188,10.6136451 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_small.4a9fd3b512e6f7ed749eebc2a3e248ad.svg";